<script> 
	import { 
		headerTitleHome, 
		linkAV,
		linkAV2,
		linkConheca,
		linkSolicite,
		linkPesquisaVendas,
		linkPesquisaLocacao,
		linkInstagram,
	} from '../store.js';
	
	import { link }         		from "svelte-routing";
	import { onMount, onDestroy  }	from 'svelte';
	import Instagram				from '../components/Instagram.svelte'

	import Vitrine          		from '../components/Vitrine.svelte'
	import Boleto           		from '../components/Boleto.svelte'
	import PopUp					from '../components/PopUp.svelte'
	import Busca					from '../components/Busca.svelte'
	import ListaImoveis				from '../components/ListaImoveis.svelte'
	
	function toggleMenu() {
		document.querySelector('header.header--hidden').classList.toggle('hidden');
	}

	function search(e) {
		const url = '/imoveis/' + (e.detail.tipo_negociacao == atria.rent?'locacao':'vendas') + '#' + Object.entries(e.detail).filter(p=>p[1].toString().length>0&&p[1].toString()!='0').flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}

	let filtrosDestaquesLocacao = {nt:atria.rent, tipo_negociacao:atria.rent, pageSize:6, random: 1, tipo_imovel:'1,4', dormitorios: '2,3,4,5,6,7,8,9,10'};
	let filtrosDestaquesVendas = {nt:atria.sell, tipo_negociacao:atria.sell, pageSize:6, random: 1};

	function activateSlickLocacao(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--locacao').style.display = 'none';
		} else {
			activateSlick('.destaques-home--locacao');
		}
	}
	function activateSlickVendas(json) {
		if (json.NumberOfItems == 0) {
			document.querySelector('.destaques-home--vendas').style.display = 'none';
		} else {
			activateSlick('.destaques-home--vendas');
		}
	}
	function activateSlick(selector) {
		window.setTimeout(()=>{            
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: 3,
				slidesToScroll: 3,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
							dots: true,
							arrows: false,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							dots: true,
							arrows: false,
						}
					}
				]
			});
		}, 500);
	}

	//Esconde cabecalho
	onMount(async () => {
		document.querySelector('body').classList.add('site--home');
	});
	onDestroy(async () => {
		document.querySelector('body').classList.remove('site--home');
		document.querySelector('header').classList.remove('hidden');
	});

	let vitrines = [
		{
			image: 'vitrineCascata20230329.jpg', 
			imageMobile: 'vitrineCascata20230329M.jpg', 
			title: 'Serra & Lar',
			href: '#'
		}
	];
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<Vitrine vitrines={vitrines} showDots={true} vitrineHeight="500px"/>

<section class="busca">
	<div class="container">	
		<Busca on:filter={search} />
	</div>
</section>

<section class="section ajuda">
	<div class="container">
		<div class="links flex sm-flex-column flex-center gap-20">
			<a href="{$linkPesquisaLocacao}" class="flex-1" title="Ir para Imóveis para alugar">
				<i class="fas fa-door-open"></i>
				<h3 class="subtitle">Imóveis para alugar</h3>
				<p>Alugue o seu imóvel ideal da forma mais segura e eficiente com a nossa equipe.</p>
			</a>
			<a href="{$linkPesquisaVendas}" class="flex-1" title="Ir para Imóveis para comprar">
				<i class="fas fa-key"></i>
				<h3 class="subtitle">Imóveis para comprar</h3>
				<p>Ofertas selecionadas e apoio especializado, para que você feche o melhor negócio.</p>
			</a>
			<a href="/administracao-condominios" class="flex-1" title="Ir para Administração de condomínios">
				<i class="far fa-building"></i>
				<h3 class="subtitle">Administração de condomínios</h3>
				<p>Seu condomínio administrado por quem entende do assunto.</p>
			</a>
		</div>
	</div>
</section>

<!-- Destaques Alugar -->
<section class="section destaques-home destaques-home--locacao">
	<div class="container">
		<div class="header pb-25">
			<div class="flex flex-center" style="width: 100%;">
				<div class="flex-1 hidden-sm hidden-xs"></div>
				<h2 class="title color-secondary">
					<a href="{$linkPesquisaLocacao}" class="color-primary">Aluguel</a> residencial e comercial
				</h2>
				<div class="flex-1 hidden-sm hidden-xs"></div>
			</div>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
		<div class="flex flex-center">
			<a class="text-bold pt-20 pb-20 hidden-lg hidden-md" href="{$linkPesquisaLocacao}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-accent"></i></a>
		</div>
	</div>
</section>

<section class="section info aplicativo">
	<a name="aplicativo"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column">
			<div class="image flex-1" style="background-image: url('assets/images/imgApp.png')"></div>
			<div class="content flex-1 flex flex-column">
				<div class="flex flex-column wp-100">
					<h2 class="header inline left-pipe">Aplicativo<br> Serra e Lar</h2>
					<p>Todos os serviços em um único lugar! <br>Utilize no seu celular, tablet ou computador. <br>Comunicação rápida, prática e segura.</p>
					<div class="flex flex-center wp-100 gap-10">
						<a href="{$linkAV}" target="_blank" class="btn btn-primary">ACESSE AQUI</a>
						<a href="{$linkConheca}" target="_blank" class="btn btn-secondary">CONHEÇA A SOLUÇÃO</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Destaques Vendas -->
<section class="section destaques-home destaques-home--vendas">
	<div class="container">
		<div class="header pb-25">
			<div class="flex flex-center" style="width: 100%;">
				<div class="flex-1 hidden-sm hidden-xs"></div>
				<h2 class="title color-secondary">
					<a href="{$linkPesquisaVendas}" class="color-primary">Venda</a> de empreendimentos e seminovos
				</h2>
				<div class="flex-1 hidden-sm hidden-xs"></div>
			</div>
		</div>
		<ListaImoveis pageSize={9} filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
		<div class="flex flex-center">
			<a class="text-bold pt-20 pb-20 hidden-lg hidden-md" href="{$linkPesquisaVendas}">Veja mais ofertas <i class="fas fa-arrow-alt-circle-right color-accent"></i></a>
		</div>
	</div>
</section>


<section class="section info sobre">
	<a name="sobre"></a>
	<div class="container container-short">
		<div class="items flex sm-flex-column gap-20">
			<div class="image flex-1" style="background-image: url('assets/images/fachada2.jpg');background-position:center;background-size:cover;"></div>
			<div class="content flex-1 flex flex-column">
				<div class="flex flex-column wp-100">
					<h2 class="header inline left-pipe">Sobre a<br> Serra & Lar</h2>
					<p>Fundada na cidade de Canela - RS em 2005, primamos pela qualidade no atendimento e pela ética profissional, atuando com muito carinho em tudo que fizemos.</p>
					<div class="flex flex-center wp-100 gap-10">
						<a href="/sobre" target="_blank" class="btn btn-primary">SAIBA MAIS</a>
						<a href="/contato" target="_blank" class="btn btn-secondary">ENTRE EM CONTATO</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section section-social">
	<div class="container">
		<div class="header">
			<h2 class="title text-center color-secondary">
				<a href="{$linkInstagram}" target="_blank" class="color-primary">@serraelar</a> nas redes sociais
			</h2>
		</div>
	</div>
	<Instagram />
</section>

<Boleto />
<PopUp channel="site" />